import { render, staticRenderFns } from "./CompareContracts.vue?vue&type=template&id=565dc5f6"
import script from "./CompareContracts.vue?vue&type=script&lang=js"
export * from "./CompareContracts.vue?vue&type=script&lang=js"
import style0 from "./CompareContracts.vue?vue&type=style&index=0&id=565dc5f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports